import { Helmet } from "react-helmet-async";
import Host from "./Host";

export default function HelmetComponent({ title, metaTitle }) {
  const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
  const resolvedTitle = metaTitle || Host?.metaTitle;
  const resolvedImage = "https://cdn.ebtida.com/1781139491834-WhatsAppImage2026-06-11at04.53.24.jpeg";

  return (
    <Helmet>
      <title>{title ? `${title} | ${metaTitle}` : metaTitle}</title>
      {metaTitle && <meta name="title" content={metaTitle} />}
      <meta name="description" content={Host?.metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="author" content={Host?.domainName} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={Host?.metaDescription} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:url" content={canonicalUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={Host?.metaDescription} />
      <meta name="twitter:image" content={resolvedImage} />

      <link rel="icon" href={Host?.favicon} type="image/x-icon" />
    </Helmet>
  );
}
